import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../../atoms/icon/icon.component';
import { FormGroup } from '@angular/forms';
import { ErrorSummaryFieldComponent } from '../../../atoms/forms/error-summary-field/error-summary-field.component';
import { ErrorTypeLabels, FieldLabels, DEFAULT_ERROR_TYPE_LABELS } from '../../../shared/interfaces/error-messages.interface';

@Component({
  selector: 'htx-form-section',
  standalone: true,
  imports: [CommonModule, IconComponent, ErrorSummaryFieldComponent],
  templateUrl: './form-section.component.html',
  styleUrl: './form-section.component.scss'
})
export class FormSectionComponent {
  /**
   * The title of the form section
   */
  title = input<string>('');

  /**
   * Optional Material Icon name to display next to the title
   */
  icon = input<string>('');

  /**
   * Optional FormGroup to display error summary from
   */
  formGroup = input<FormGroup | undefined>(undefined);

  /**
   * Title for the error summary component
   */
  errorSummaryTitle = input<string>('Validation Errors');

  /**
   * Whether to show the error summary component
   */
  showErrorSummary = input<boolean>(true);

  /**
   * Which control names to check for errors
   */
  controlNames = input<string[] | undefined>(undefined);

  /**
   * Labels for form fields to display in the error summary
   */
  fieldLabels = input<FieldLabels>({});

  /**
   * Custom labels for error types
   */
  errorTypeLabels = input<ErrorTypeLabels>(DEFAULT_ERROR_TYPE_LABELS);
}
